module.exports = __webpack_public_path__ + "img/home.ab8b4942.jpg";